// extracted by mini-css-extract-plugin
module.exports = {"channelsContainer":"FieldsetContainer_channelsContainer___vj9c"};